import React from 'react'

import Reflux from 'reflux-react-16'
import moment from 'moment'

import AdminStore from '../../stores/AdminStore.js'
import AdminActions from '../../actions/AdminActions.js'
import LoginActions from '../../actions/LoginActions.js'

import {NewReseller, EditReseller} from './components/resellers/index.js'
import {Button, IconButton, Popup, P, Row, Modal} from '../../components/UI/index.js'
import Table from '../../components/UI/table/index.js'
import downloadFile from '../../utils/downloadFile.js'
import {formSpacing} from '../../components/UI/forms/index.js'
import createMemo from '../../utils/createMemo.js'

export default class Resellers extends Reflux.Component {
    constructor(props) {
        super(props)

        this.columnsMemo = createMemo()

        this.state = {
            selectedResellers: [],
            viewArchived: false
        }
        this.stores = [AdminStore]
    }

    onClickNew() {
        AdminActions.selectReseller(NewReseller())
    }

    onClickSelect(reseller) {
        AdminActions.selectReseller(reseller)
    }

    onClickLogin(reseller, event) {
        event.stopPropagation()

        LoginActions.loginAsReseller(reseller._id, undefined, (err) => {
            if (err) {
                this.popup.open('Foutmelding', '', () => {})
                this.popup.setError(err)
            }
        })
    }

    onViewArchived() {
        const {viewArchived} = this.state

        AdminActions.getResellers(true, !viewArchived)

        this.setState({viewArchived: !viewArchived})
    }

    // The same columns until a value they read changes: new columns re-render every row of the table
    columns() {
        return this.columnsMemo([this.props.history, this.state.viewArchived], () => this.buildColumns())
    }

    buildColumns() {
        const {history} = this.props

        return [
            {id: 'name', title: 'Naam', visible: true, width: 250, onClick: (reseller) => {
                AdminActions.selectReseller(reseller)
            }, text: (reseller) => {
                return (reseller.settings?.accountName && reseller.settings?.accountName !== reseller.name) ? `${reseller.settings?.accountName} (${reseller.name})` : reseller.name
            }},
            {
                id: 'startDate', title: 'Startdatum', visible: true, width: 100, sort: (reseller) => {
                    return reseller.startDate
                }, text: (reseller) => {
                    return moment(reseller.startDate).format('DD-MM-YYYY')
                }
            },
            {
                id: 'invoice', title: 'Factureren', visible: true, width: 80, text: (reseller) => {
                    return reseller?.noInvoice && !reseller.invoiceResellerId ? 'Nee' : 'Ja'
                }
            },
            {
                id: 'debtorCode', title: 'Debiteurnummer', visible: true, flex: 1, text: (reseller) => {
                    return reseller.debtorCode || reseller.invoiceResellerId
                }
            },
            {
                id: 'lastInvoice', title: 'Laatste factuur', visible: true, key: 'lastInvoice', width: 100, text: (reseller) => {
                    return reseller.lastInvoice ? moment(reseller.lastInvoice).format('DD-MM-YYYY') : ''
                }
            },
            {
                id: 'settings.companyAddress.city', title: 'Hoofdlocatie', visible: true, key: 'settings.companyAddress.city', width: 100
            },
            {
                id: 'archived', title: 'Gearchiveerd', visible: this.state.viewArchived, width: 80, text: (reseller) => {
                    return reseller?.isArchived ? `Ja (${moment(reseller?.archivedTime, 'DD-MM-YYYY HH:mm').format('DD-MM-YYYY')})` : ''
                }
            },
            {id: 'logs', title: 'Bekijk logs', visible: true, width: 120, render: (reseller) => {
                return (
                    <IconButton
                        onClick={() => {
                            history?.push(`/admin/logs?resellerId=${reseller._id}`)
                        }}
                    >
                        <i className='mdi mdi-text-box-search-outline' />
                    </IconButton>
                )
            }},
            {id: 'login', visible: true, width: 50, render: (reseller) => {
                return (
                    <IconButton onClick={this.onClickLogin.bind(this, reseller)}>
                        <i className='mdi mdi-login' />
                    </IconButton>
                )
            }}
        ]
    }

    async exportQLS() {
        const ngsResellers = this.state.resellers.filter((reseller) => reseller.groups?.includes('NGS')).map((reseller) => reseller.name)
        const startDate = moment().startOf('month').subtract(1, 'month').format('YYYY-MM-DD')
        const endDate = moment().startOf('month').subtract(1, 'd').format('YYYY-MM-DD')

        this.popup.setInputs([
            {name: 'resellerNames', label: 'Resellers', type: 'select', values: ngsResellers, options: this.state.resellers.map((reseller) => ({title: reseller.settings.accountName || reseller.name, value: reseller.name}))},
            {name: 'startDate', label: 'Startdatum', value: startDate, type: 'date'},
            {name: 'endDate', label: 'Einddatum', value: endDate, type: 'date'}
        ])

        const values = await this.popup.open('Export QLS aantallen', 'Weet u zeker dat u de QLS aantallen wilt exporteren?')
        if (!values) return

        AdminActions.exportQLS(values.resellerNames, values.startDate, values.endDate, (err, csv) => {
            if (err) {
                this.popup.setError(err)
            } else {
                // Download csv
                downloadFile(`QLS_aantallen_${values.startDate}-${values.endDate}`, csv, 'text/csv')

                this.popup.close()
            }
        })
    }

    render() {
        const {resellers, selectedReseller, resellersLoading, selectedResellers, viewArchived} = this.state

        return (
            <div style={{display: 'flex', minHeight: '100%', paddingTop: 30, paddingLeft: 24, paddingRight: 24}}>
                <div style={{display: 'flex', flexDirection: 'column', width: '100%', height: '100%'}}>
                    <div style={{display: 'flex', columnGap: formSpacing.columnGap, marginBottom: 30}}>
                        <Button onClick={this.onClickNew.bind(this)}>Nieuwe reseller</Button>

                        <Button onClick={() => this.exportQLS()}>Export QLS aantallen</Button>

                        <Row style={{alignItems: 'center', width: 'fit-content'}}>
                            <P>{viewArchived ? 'Verberg' : 'Toon'} gearchiveerde resellers</P>
                            <IconButton icon={viewArchived ? 'mdi mdi-eye-off' : 'mdi mdi-eye'} onClick={this.onViewArchived.bind(this)} />
                        </Row>
                    </div>

                    <Table
                        loading={resellersLoading}
                        noPagination
                        tableName='Resellers'
                        columns={this.columns()}
                        rows={resellers}
                        selectedRows={selectedResellers}
                        onChange={(selectedResellers) => this.setState({selectedResellers})}
                        ref={(ref) => this.table = ref}
                    />

                </div>

                <Modal show={!!selectedReseller} onClose={() => AdminActions.selectReseller(null)} title={selectedReseller?._id ? 'Reseller bewerken' : 'Nieuwe reseller'}>
                    <EditReseller reseller={selectedReseller} resellers={resellers} viewArchived={viewArchived} />
                </Modal>

                <Popup ref={(ref) => this.popup = ref} />
            </div>
        )
    }
}
